import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgSpinner = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M11.25 2.75A.75.75 0 0 1 12 2 10 10 0 1 1 2 12a.75.75 0 0 1 1.5 0A8.5 8.5 0 1 0 12 3.5a.75.75 0 0 1-.75-.75"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgSpinner;
